import script from "./FooterIlot.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterIlot.vue?vue&type=script&setup=true&lang=js"

import "./FooterIlot.vue?vue&type=style&index=0&id=c2d06b7e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2d06b7e"]])

export default __exports__